import { Tooltip } from '@material-ui/core';
import React from 'react';
import { SUPPLIER_GRADE, SUPPLIER_STATUS } from 'features/supplier/utils';

import NoData from '@components/NoData';

import InfoPopUp from '@features/supplier/component/InfoPopUp';

import { replaceUnderLine } from '@utils/Util';

const SupplierListImageView = ({ isLoading, onSupplierClick, allSuppliers }) => {
	return (
		<>
			{allSuppliers?.data?.length === 0 && !isLoading && <NoData message={'No result found'} />}
			<div className="supplier-row">
				{allSuppliers?.data?.map((item) => (
					<div
						className="supplier-card-single cursor-pointer"
						key={item?.id}
						onClick={() => onSupplierClick(item)}
					>
						<div className="supplier-img">
							<img
								src={
									item?.profileImageDocUrl ||
									`${process.env.PUBLIC_URL}/images/factory-demo.jpg`
								}
								alt="add"
							/>

							<div className="supplier-status">
								<span
									className={`status ${
										SUPPLIER_STATUS[item?.supplierStatus?.constant]
									} mr-2`}
								>
									{item?.supplierStatus?.name}
								</span>
								{!item?.isVisited && (
									<span className="status red-3 mr-1 mb-2">Audit Pending</span>
								)}
							</div>
						</div>
						<div className="supplier-card-content">
							<div className="title-and-grade d-flex justify-content-between align-items-center">
								<div>
									<h3 className="semibold-20 font-weight-bold">{item?.name}</h3>
								</div>
								<div className="grade-list">
									<span
										className={`factory-grade  ${
											SUPPLIER_GRADE[item?.supplierGrading?.constant]
										} font-weight-bold`}
									>
										{item?.supplierGrading?.name && (
											<InfoPopUp
												gradeId={item?.supplierGrading?.constant}
												iconType={'GRADE'}
												hoverTag={item?.supplierGrading?.name}
											/>
										)}
									</span>
								</div>
							</div>
							<p className="regular-12 gray_dark_02">
								{item?.cityResponse}
								{item?.countryResponse && `, ${item?.countryResponse?.name}`}
							</p>
							<div className="status-nav">
								<ul className="d-flex flex-wrap justify-content-start">
									{item?.supplierTypeList?.map((type) => (
										<li className="mr-1" key={`type_${type}`}>
											<span className="status cyan-1">{type}</span>
										</li>
									))}

									{item?.supplierCategoryList?.map((category) => (
										<li className="mr-1" key={`type_${category}`}>
											<span className="status pink-1">
												{replaceUnderLine(category, true)}
											</span>
										</li>
									))}
								</ul>
							</div>
							<div className="brand-nav">
								<ul className="d-flex flex-wrap justify-content-start">
									{item?.brandList?.slice(0, 3)?.map((brand) => (
										<li className="mr-1" key={`type_${brand?.id}`}>
											<span className="status gray-1 radius">{brand?.name}</span>
										</li>
									))}
									{item?.brandList?.length > 3 && (
										<>
											<Tooltip
												title={item?.brandList?.slice(3)?.map((brand) => (
													<span
														className="brand-common-design mr-1 mb-1"
														key={`type_${brand?.id}`}
													>
														{brand?.name}
													</span>
												))}
												placement="top"
												arrow
											>
												<li>
													<span className="status gray-1 radius">
														+{parseInt(item?.brandList?.length) - 3}
													</span>
												</li>
											</Tooltip>
										</>
									)}
								</ul>
							</div>
						</div>
					</div>
				))}
			</div>
		</>
	);
};

export default SupplierListImageView;
